import { checkinApi } from '@/services/api/httpClient';

const admissionMedicalOrdersActions = {
  async getMedicalOrdersByAdmissionId({ commit, state }) {
    const admissionId = state.data.id;
    const url = `/exam/${admissionId}`;
    try {
      const getAdmissionMedicalOrders = await checkinApi().get(url);

      const medicalOrders = getAdmissionMedicalOrders.data;

      if (medicalOrders.length) {
        await commit('SET_ADMISSION_MEDICAL_ORDERS', medicalOrders);
      }

      return medicalOrders;
    } catch (error) {
      return [];
    }
  },

  async createMedicalOrders({ commit, _, getters }) {
    commit('enableLoader', true);
    const dateNow = new Date();
    dateNow.setTime(dateNow.getTime() + 0.25 * 60 * 60 * 1000);
    const admissionId = this.getters.getCurrentAdmissionState.data.id;
    const exams = getters.getSearchExamsState.data.manuallySelectedExams;

    if (!admissionId || !exams.length) return;

    const payload = {
      exams: exams.map((exam) => ({
        examCode: exam.id.toString(),
        status: 'WAITING',
        schedulingDate: dateNow.toISOString(),
        price: exam.price,
      })),
    };

    const url = `admission/${admissionId}/medical-orders`;

    try {
      const response = await checkinApi().post(url, payload);

      const medicalOrders = response?.data;

      commit('SET_ADMISSION_MEDICAL_ORDERS', medicalOrders);

      return medicalOrders;
    } catch (error) {
      console.error(error);
    } finally {
      commit('enableLoader', false);
    }
  },

  async updateMedicalOrders({ commit, state }, payload) {
    const admissionId = state.data.id;
    const url = `admission/${admissionId}/update-medical-orders`;

    try {
      const updateAdmissionMedicalOrders = await checkinApi().patch(url, { ...payload });

      const medicalOrders = updateAdmissionMedicalOrders.data;
      if (medicalOrders.length) {
        await commit('SET_ADMISSION_MEDICAL_ORDERS', medicalOrders);
      }

      return medicalOrders;
    } catch (error) {
      return [];
    }
  },
};

export default admissionMedicalOrdersActions;
